import { Box, Stack } from "@mui/material";
import { memo } from "react";
import type { ApiError } from "@entrilia/shared/api/types";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import { logError } from "@entrilia/shared/logging";
import type { DataImportInfo, DataImportMetadata } from "../../../../../api/types/dataImportTypes";
import type { ResourceChangeProgressNotification } from "../../../../../api/types/resourceChangesTypes";
import ReviewImport from "../../../import-data/csv-import/review-import/ReviewImport";
import { isImportOperationRunning } from "../../../import-data/importDataStateHelper";
import RunningOperationAlert from "../../../import-data/RunningOperationAlert";

interface Props {
  dataImport?: DataImportInfo;
  dataImportMetadata?: DataImportMetadata;
  fetchError?: ApiError;
  progress?: ResourceChangeProgressNotification;
  onRefresh: () => void;
}

const DataImportPanelBody = ({ dataImport, dataImportMetadata, fetchError, progress, onRefresh }: Props) => {
  if (fetchError) {
    logError(fetchError, "[DataImportPanelBody] load");
    return <DataLoadingFailed title="Loading data import failed" />;
  }

  if (dataImport === undefined || dataImportMetadata === undefined) {
    return <InlineLoader />;
  }

  return (
    <>
      {isImportOperationRunning(dataImport) && (
        <Box sx={{ pt: 2, px: 3 }}>
          <RunningOperationAlert dataImport={dataImport} progress={progress} onRefresh={onRefresh} />
        </Box>
      )}
      <Stack sx={{ flex: 1, minHeight: 0 }}>
        <ReviewImport dataImport={dataImport} dataImportMetadata={dataImportMetadata} readOnly />
      </Stack>
    </>
  );
};

export default memo(DataImportPanelBody);
